var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from 'root/src/client/web/base/Icon';
import KeySkeleton from 'root/src/client/public/icons/key-skeleton';
import { colorsNew } from 'root/src/client/web/commonStyles';
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography';
import ProgressBar from 'root/src/client/web/base/ProgressBar';
import TooltipWrapper from 'root/src/client/web/base/TooltipWraper';
import ButtonNew from 'root/src/client/web/base/ButtonNew';
import { HeroSectionStyle } from 'root/src/client/web/record/DropEvent/styles';
import { clamp } from 'remeda';
import { withStylesHof } from 'root/src/client/util/withStylesHof';
import Anchor from 'root/src/client/web/base/Anchor';
import ANCHORS from 'root/src/shared/constants/anchors';
import { getRewardTypeName } from 'root/src/shared/rewards/helpers/rewardType.helpers';
const NeonButton = withStylesHof(HeroSectionStyle, { name: 'MuiRewardButton' }, (_a) => {
    var { classes, title } = _a, rest = __rest(_a, ["classes", "title"]);
    return (<ButtonNew className={classes.rewardButton} type="secondary" style={{ flex: 1 }} {...rest}>
			<Typography variant={typographyVariants.button}>
				{title}
			</Typography>
		</ButtonNew>);
});
const UnStyledPrizesAvailableProgressBar = ({ classes, initialProduct, comingSoon, isAuthenticated, displaySignUpModule, }) => {
    var _a;
    const [initialProductData] = initialProduct;
    if (!initialProductData) {
        return null;
    }
    const { available, used } = initialProductData;
    const total = available + used;
    const prizesPercentage = total > 0 ? (available / total * 100) : 0;
    return (<div className="AvailableProgressBar">
			<div className={classes.availableInfo}>
				<Icon icon={KeySkeleton} size={24} color={colorsNew.pink}/>
				<Typography variant={typographyVariants.heading3}>
					<span style={{ marginLeft: 8, marginRight: 10 }}>{Math.max(0, available)}</span>
					{getRewardTypeName(initialProductData.type, { amount: total, capitalize: true })}
				</Typography>
			</div>
			<div className={classes.progresBarWrapper}>
				<div className={classes.availableKeys}>
					<ProgressBar progress={prizesPercentage} progressBackgroundColor={colorsNew.white} progressBarColor={colorsNew.pink} progressBackgroundStyle={{
            height: 18,
            width: '100%',
        }}/>
				</div>
				<TooltipWrapper tooltipText={comingSoon
            ? 'You\'ll be able to accept a dare once the Drop is live!'
            : initialProduct[0]
                ? `Accept a dare and get a ${(_a = initialProduct[0]) === null || _a === void 0 ? void 0 : _a.name}!`
                : 'Accept a dare and get prizes!'}>
					{isAuthenticated ? (<Anchor anchor={ANCHORS.DROP_ALL_DARES}>
							<NeonButton title="Reward!"/>
						</Anchor>) : (<NeonButton title="Reward!" onClick={displaySignUpModule}/>)}
				</TooltipWrapper>
			</div>
			<div className={classes.remainingPrizes}>
				<Typography style={{ marginBottom: 10, display: 'block' }} variant={typographyVariants.micro} color={colorsNew.light3}>
					Remaining out of {total} total{' '}
					{getRewardTypeName(initialProductData.type, { amount: total, capitalize: true })}
				</Typography>
			</div>
		</div>);
};
const UnStyledPointsAvailableProgressBar = ({ classes, pointsLimit, pointsAwarded = 0, pointsReserved = 0, canUserReclaimReservation, displayHowToEarnPointsModal, }) => {
    const pointsAwardedLimited = clamp(Math.round(pointsAwarded), { min: 0, max: pointsLimit });
    const pointsRemaining = Math.max(0, pointsLimit - pointsAwardedLimited - pointsReserved);
    const pointsPercentage = (pointsRemaining / pointsLimit) * 100;
    return (<div>
			<div className={classes.availableInfo}>
				<Typography variant={typographyVariants.heading3}>
					<span style={{ marginLeft: 8, marginRight: 10 }}>{pointsRemaining.toLocaleString()}</span>
					Points
				</Typography>
			</div>
			<div className={classes.progresBarWrapper}>
				<ProgressBar progress={pointsPercentage} progressBackgroundColor={colorsNew.white} progressBarColor={colorsNew.teal} progressBackgroundStyle={{
            height: 18,
            width: '100%',
        }}/>
				{canUserReclaimReservation && (<NeonButton title="Reserve" onClick={() => displayHowToEarnPointsModal
                && displayHowToEarnPointsModal({ canUserReclaimReservation })}/>)}
			</div>
			<div className={classes.remainingPrizes}>
				<Typography style={{ marginBottom: 10, marginTop: 10, display: 'block' }} variant={typographyVariants.micro} color={colorsNew.light3}>
					Remaining out of {pointsLimit.toLocaleString()} total points
				</Typography>
			</div>
		</div>);
};
export const PrizesAvailableProgressBar = withStylesHof(HeroSectionStyle, { name: 'MuiPrizesAvailableProgressBar' }, UnStyledPrizesAvailableProgressBar);
export const PointsAvailableProgressBar = withStylesHof(HeroSectionStyle, { name: 'MuiPointsAvailableProgressBar' }, UnStyledPointsAvailableProgressBar);
